/**
 * Filename sanitization utility
 * Sanitizes strings for use in filenames, keeping Serbian characters
 */

/**
 * Sanitizes a string for use in a filename.
 * Removes/replaces special characters, keeps Serbian characters.
 * 
 * @param {string|null|undefined} str
 * @returns {string}
 */
export function sanitizeFilename(str) {
  if (!str) return '';
  // Replace spaces with underscores
  str = str.replace(/\s+/g, '_');
  // Replace special characters (except letters, numbers, underscores, hyphens, and Serbian characters) with underscores
  // Serbian characters: č, ć, đ, š, ž, Č, Ć, Đ, Š, Ž
  str = str.replace(/[^a-zA-Z0-9_-čćđšžČĆĐŠŽ]/g, '_');
  // Remove multiple consecutive underscores
  str = str.replace(/_+/g, '_');
  // Trim underscores from start and end
  str = str.replace(/^_+|_+$/g, '');
  return str;
}

/**
 * Removes trailing underscores before file extension in a filename.
 * 
 * @param {string} filename
 * @param {string} extension - File extension (e.g., '.pdf', '.xlsx')
 * @returns {string}
 */
export function removeTrailingUnderscores(filename, extension = '.pdf') {
  const escapedExtension = extension.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp('_+' + escapedExtension + '$');
  return filename.replace(regex, extension);
}

// Also expose globally for IIFE scripts that don't use ES modules
if (typeof window !== 'undefined') {
  window.FilenameSanitizer = {
    sanitize: sanitizeFilename,
    removeTrailingUnderscores: removeTrailingUnderscores
  };
}
